import raw from "../rawClients/rawPaddClient";
import { jsonify, sanitize } from "../generated/TapiocaUtils";
import { ArrayToCommaSeparatedList } from "../util/helper";
/**
 * This will eventually be replaced with a generated client.
 */
export default {
  get NAME() {
    return "bridgeClient";
  },
  transactions: {
    sent: {
      one: transactionUid =>
        raw.get(`/v1/transaction/sent_transaction/${transactionUid}`),
      // `list` deprecated, use `all` instead
      list: (projectUid, params) =>
        raw.get({
          url: `/v1/project/${projectUid}/sent_transactions`,
          params: sanitize(params || {}),
        }),
      all: params =>
        raw.get({
          url: `/v1/sent_transactions`,
          params: sanitize(params || {}),
        }),
    },
    received: {
      one: transactionUid =>
        raw.get(`/v1/transaction/received_transaction/${transactionUid}`),
      // `list` deprecated, use `all` instead
      list: (projectUid, params) =>
        raw.get({
          url: `/v1/project/${projectUid}/received_transactions`,
          params: sanitize(params || {}),
        }),
      all: params =>
        raw.get({
          url: `/v1/received_transactions`,
          params: sanitize(params || {}),
        }),
    },
  },
  assets: {
    sent: (transactionUid, params) =>
      raw.get({
        url: `/v1/sent_transaction/${transactionUid}/assets`,
        params: sanitize(params || {}),
      }),
    received: (transactionUid, params) =>
      raw.get({
        url: `/v1/received_transaction/${transactionUid}/assets`,
        params: sanitize(params || {}),
      }),
  },
  automations: {
    activate: (sourceProjectId, targetProjectId) =>
      raw.patch(
        `/v1/automations/${sourceProjectId}/${targetProjectId}/activate`,
        {}
      ),
    activateBatch: body =>
      raw.patch(`/v1/automations/activate:batch`, jsonify(body)),
    deactivate: (sourceProjectId, targetProjectId) =>
      raw.patch(
        `/v1/automations/${sourceProjectId}/${targetProjectId}/deactivate`,
        {}
      ),
    deactivateBatch: body =>
      raw.patch(`/v1/automations/deactivate:batch`, jsonify(body)),
    //@deprecated don't use this endpoint (network).
    network: (projectId, params) =>
      raw.get({
        url: `/v1/automations/neighbors/${projectId}`,
        params: sanitize(params || {}),
      }),
    list: params =>
      raw.get({
        url: "/v1/automations",
        params: sanitize(
          {
            ...params,
            asset_types:
              params && params.asset_types
                ? ArrayToCommaSeparatedList(params.asset_types)
                : undefined,
            fields:
              params && params.fields
                ? ArrayToCommaSeparatedList(params.fields)
                : undefined,
          } || {}
        ),
      }),
    delete: {
      one: (sourceProjectUid, target, params) =>
        raw.delete({
          url: `/v1/automations/${sourceProjectUid}/${target}`,
          params: sanitize(params || {}),
        }),
      batch: body => raw.post("/v1/automations:batch-delete", jsonify(body)),
    },
  },
  bridge: {
    bridge_invites: {
      create: body => raw.post("/v1/bridge-requests", jsonify(body)),
      get: bridgeInviteId => raw.get(`/v1/bridge-requests/${bridgeInviteId}`),
      list: params =>
        raw.get({
          url: "/v1/bridge-requests",
          params: sanitize(params),
        }),
      resend: bridgeInviteId =>
        raw.get(`/v1/bridge-requests/${bridgeInviteId}/resend`),
      // If response contains nextUrl, there are more results to check
      neighbors: (bridgeInviteId, params) =>
        raw.get({
          url: `/v1/bridge-requests/${bridgeInviteId}/sender-neighbors`,
          params: sanitize(params || {}),
        }),
      withdraw: bridgeInviteId =>
        raw.delete(`/v1/bridge-requests/${bridgeInviteId}`),
    },
    bridges: {
      create: body => raw.post("/v1/bridges", jsonify(body)),
      delete: (bridgeId, params) =>
        raw.delete({
          url: `/v1/bridges/${bridgeId}`,
          params: sanitize(params),
        }),
      list: params =>
        raw.get({
          url: "/v1/bridges",
          params: sanitize(params),
        }),
    },
  },
};
